export * from './icp-presets';

export const APP_NAME = 'Traction Bee';

export const LEADS_PER_DAY_DEFAULT = 3;

export const TRIAL_DURATION_DAYS = 14;

export const ONBOARDING_STEPS = [
  'account',
  'founder_profile',
  'company_profile',
  'icp_definition',
  'outreach_preferences',
  'completed',
] as const;

export const COMPANY_SIZES = [
  '1-10',
  '11-50',
  '51-200',
  '201-500',
  '501-1000',
  '1001-5000',
  '5000+',
] as const;

export const FUNDING_STAGES = [
  'Pre-seed',
  'Seed',
  'Series A',
  'Series B',
  'Series C+',
  'Bootstrapped',
  'Public',
] as const;

export const INDUSTRIES = [
  'SaaS',
  'Fintech',
  'Healthtech',
  'Edtech',
  'E-commerce',
  'Marketplace',
  'Developer Tools',
  'AI/ML',
  'Cybersecurity',
  'Enterprise Software',
  'Consumer Tech',
  'Hardware',
  'Other',
] as const;

export const TARGET_ROLES = [
  'CEO',
  'CTO',
  'COO',
  'CFO',
  'VP Engineering',
  'VP Product',
  'VP Sales',
  'VP Marketing',
  'Head of Growth',
  'Director',
  'Founder',
  'Co-Founder',
] as const;

export const TONES_OF_VOICE = [
  { value: 'formal', label: 'Formal' },
  { value: 'casual', label: 'Casual' },
  { value: 'friendly', label: 'Friendly' },
] as const;

export const VERTICAL_NICHES = [
  'AI/ML Startups',
  'Developer Tools',
  'B2B SaaS',
  'Fintech Companies',
  'Healthtech Startups',
  'E-commerce Brands',
  'Marketing Agencies',
  'HR Tech',
  'Edtech Companies',
  'Cybersecurity Firms',
  'Real Estate Tech',
  'Legal Tech',
  'Logistics & Supply Chain',
  'Climate Tech',
  'Gaming & Entertainment',
] as const;

export const ROUTES = {
  HOME: '/',
  ABOUT: '/about',
  FEATURES: '/features',
  BENEFITS: '/benefits',
  COMPARE: '/compare',
  FAQ: '/faq',
  PRICING: '/pricing',
  LOGIN: '/login',
  SIGNUP: '/signup',
  VERIFY_EMAIL: '/verify-email',
  RESET_PASSWORD: '/reset-password',
  ONBOARDING: '/onboarding',
  DASHBOARD: '/dashboard',
  MORNING_BRIEF: '/morning-brief',
  LEADS: '/leads',
  MATCHING: '/dashboard/matching',
  WARM_INTROS: '/dashboard/warm-intros',
  LEADS_IMPORT: '/leads/import',
  DO_NOT_CONTACT: '/leads/do-not-contact',
  SETTINGS: '/settings',
  SETTINGS_PROFILE: '/settings/profile',
  SETTINGS_COMPANY: '/settings/company',
  SETTINGS_ICP: '/settings/icp',
  SETTINGS_OUTREACH: '/settings/outreach',
  SETTINGS_SUBSCRIPTION: '/settings/subscription',
  ADMIN: '/admin',
  ADMIN_USERS: '/admin/users',
  ADMIN_ANALYTICS: '/admin/analytics',
  ADMIN_AGENTS: '/admin/agents',
  STATUS: '/status',
  TERMS: '/terms',
  PRIVACY: '/privacy',
  SMS_COMPLIANCE: '/sms-compliance',
  EMAIL_COMPLIANCE: '/email-compliance',
  SUPPORT: '/support',
  EXTENSION_AUTH: '/extension-auth',
  EXTENSION_INSTALL: '/extension',
} as const;
